import { Route } from '@angular/router';

export const chatRoutes: Route[] = [
    {
        path: 'chats',
        loadComponent: () =>
            import('./pages/private-chats/private-chats.component').then((c) => c.PrivateChatsComponent),
    },
    {
        path: 'chats/:id',
        loadComponent: () =>
            import('./pages/private-chat-conversation/private-chat-conversation.component').then(
                (c) => c.PrivateChatConversationComponent
            ),
    },
];
